
import useAppStore from '@/store/app';
import { format, formatDistanceToNow, parseISO, isValid } from 'date-fns';
const serverDateFormat = 'yyyy-MM-dd'

export function isValidDate(input: any) {
  if (typeof (input) != "string") { return false; }

  if (!input.endsWith("Z")) { input = input + "Z" }
  const parsed = parseISO(input);

  return isValid(parsed)
}

export function serverDateToInputValue(input: any) {
  if (!input) { return null; }
  // input is in format:  "2022-11-04T18:09:22.2406416"

  // input needs  YYYY-MM-DD as format
  return format(ensureIsDate(input), serverDateFormat);
}

export function inputValueToServerDate(input: string): any {
  if (!input) { return null; }

  // input is in format  YYYY-MM-DD 
  return format(ensureIsDate(input), serverDateFormat);
}

export function ensureIsDate(input: string | Date): Date {
  if (input == null) { return null; }

  if (typeof (input) == "string") {
    if (!input.endsWith("Z")) { input = input + "Z" }

    return parseISO(input); // input is UTC  Z => means it is in utc
  } else {
    return input;
  }
}

export function toMinuteOfHour(input: Date | string) {
  // used in charting
  const date = ensureIsDate(input);

  if (date.getMinutes() == 0) {
    return format(date, "HH:mm");
  } else {
    return format(date, "mm");

  }
}

export function toDate(input: Date | string) {
  // used in charting
  const date = ensureIsDate(input);
  return format(date, "MMM dd yyyy");

}

export function displayDistanceToNowDate(input: Date | string) {
  const date = ensureIsDate(input);

  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: useAppStore().locale,
    includeSeconds: true,
  });
}

export function displayDate(input: Date | string, onlyDatePart?: boolean) {
  const date = ensureIsDate(input);

  const formatting = onlyDatePart ? 'MMM dd, yyyy' : 'MMM dd, yyyy HH:mm:ss';

  return format(date, formatting, {
    locale: useAppStore().locale
  });
}

export function dateToTicks(input: Date | string) {
  const date = ensureIsDate(input);
  return ((date.getTime() * 10000) + 621355968000000000);
}

